import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { CdnFile } from '@ng-cloud/badger-core';
import { StartCasePipe } from '@ng-cloud/badger-core/common/pipes/start-case.pipe';
import { LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';

@Component({
  selector: 'bt-image-viewer-dialog',
  templateUrl: './image-viewer-dialog.component.html',
  styleUrls: ['./image-viewer-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LayoutAlignDirective,
    LayoutDirective,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    MatTab,
    MatTabGroup,
    StartCasePipe
  ]
})
export class ImageViewerDialogComponent {
  title: string;
  images: CdnFile[];
  selectedImageIndex: number;

  constructor(
    public dialogRef: MatDialogRef<ImageViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.images = data.images;
    this.selectedImageIndex = data.selectedIndex;
  }
}
